import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { post } from "../../../helpers/api_helper";
import ResetPasswordForm from "../../../components/shared/ResetPasswordForm";
import { ROUTES } from "../..";

const ResetPassword = () => {
  const location = useLocation();
  const { email, otp } = location.state || {};
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    try {
      const response = await post("/user/reset/password", {
        otp,
        email: email,
        newPassword: values.password,
      });
      if (response?.success) {
        toast.success(response.message);
        navigate("/login");
      }
    } catch (error) {
      toast.error(error?.message);
      console.error("Error resetting password:", error?.message);
    }
  }

  return (
    <>
      <div className="formInner">
          <div className="top py-2 text-center">
            <h2 className="m-0 fw-sbold head">Reset Password!</h2>
            <p className="m-0 py-1">Please enter your new password</p>
          </div>
        <ResetPasswordForm
          onSubmit={handleSubmit}
        />
        <div className="text-center mt-3">
          <p className="m-0 fw-sbold">
            Remembered your password?{" "}
            <Link className="themeClr" to={ROUTES.LOGIN}>
              Log In
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
